import ApiService from 'app/services/ApiService';

export const GET_KEYUSER_LIST_REQUEST = 'GET_KEYUSER_LIST_REQUEST'
export const GET_KEYUSER_LIST_SUCCESS = 'GET_KEYUSER_LIST_SUCCESS'
export const GET_KEYUSER_LIST_FAILURE = 'GET_KEYUSER_LIST_FAILURE'

export const GET_KEYUSER_FILTER_REQUEST = 'GET_KEYUSER_FILTER_REQUEST'
export const GET_KEYUSER_FILTER_SUCCESS = 'GET_KEYUSER_FILTER_SUCCESS'
export const GET_KEYUSER_FILTER_FAILURE = 'GET_KEYUSER_FILTER_FAILURE'

export const SAVE_PAGINATION = 'SAVE_PAGINATION';
export const SAVE_FILTER = 'SAVE_FILTER';
export const CLEAR_REDUCER = 'CLEAR_REDUCER';

export const getFiltersKeyUsers = () => dispatch => {
    dispatch({ type: GET_KEYUSER_FILTER_REQUEST });
    ApiService.getListKUFilters().then(
        response => {

            dispatch({
                type: GET_KEYUSER_FILTER_SUCCESS,
                payload: response
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_KEYUSER_FILTER_FAILURE, payload: error.response.message });
        }
    )
}

export const getKeyUsers = (params) => dispatch => {
    dispatch({ type: GET_KEYUSER_LIST_REQUEST });
    ApiService.getListKeyUsers(params).then(
        response => {
           
            dispatch({
                type: GET_KEYUSER_LIST_SUCCESS,
                payload: response.Data
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_KEYUSER_LIST_FAILURE, payload: error.response.message });
        }
    )
}

export const exportXls = (param) => dispatch => {
    let objValidate = {}

    for (const [key, value] of Object.entries(param)) {
        if (value) {
            objValidate[key] = value
        }
    }

    //dispatch({ type: EXPORT_DAILY_COMPLIANCE_REQUEST });
    ApiService.getPrintListUsers(objValidate).then(
        result => {
            const blob = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            downloadFile(blob, "ListadoKU.xlsx");

           // dispatch({ type: EXPORT_DAILY_COMPLIANCE_SUCCESS });
        }
    ).catch(
       
    )
}

const downloadFile = (blob, fileName) => {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.append(link);
    link.click();
    link.remove();
    window.addEventListener('focus', e => URL.revokeObjectURL(link.href), { once: true });
};

